import rich from './xAxis.axisLabel.rich'

export default {
  name: "axisLabel",
  nickname: "文本",
  desc: "坐标轴刻度标签的相关设置。",
  type: "object",
  props: {
    show: {
      name: "show",
      nickname: "显示",
      desc: "是否显示刻度标签。",
      value: true,
      defaultValue: true,
      type: "pureValue",
    },
    interval: {
      name: "interval",
      nickname: "间隔",
      desc: "坐标轴刻度标签的显示间隔，在类目轴中有效。",
      value: "auto",
      defaultValue: "auto",
      type: "pureValue",
    },
    inside: {
      name: "inside",
      nickname: "内部",
      desc: "刻度标签是否朝内，默认朝外。",
      value: false,
      defaultValue: false,
    },
    rotate: {
      name: "rotate",
      nickname: "旋转",
      desc:
        "刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠。",
      value: 0,
      defaultValue: 0,
    },
    margin: {
      name: "margin",
      nickname: "外边距",
      desc: "刻度标签与轴线之间的距离。",
      value: 8,
      defaultValue: 8,
      type: "pureValue",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "刻度标签的内容格式器，支持字符串模板和回调函数两种形式。",
    },
    showMinLabel: {
      name: "showMinLabel",
      nickname: "显示最小文本",
      desc:
        '是否显示最小 tick 的 label。可取值 <code class="codespan">true</code>, <code class="codespan">false</code>, <code class="codespan">null</code>。默认自动判定（即如果标签重叠，不会显示最小 tick 的 label）。',
    },
    showMaxLabel: {
      name: "showMaxLabel",
      nickname: "显示最大文本",
      desc:
        '是否显示最大 tick 的 label。可取值 <code class="codespan">true</code>, <code class="codespan">false</code>, <code class="codespan">null</code>。默认自动判定（即如果标签重叠，不会显示最大 tick 的 label）。',
    },
    color: {
      name: "color",
      nickname: "颜色",
      desc:
        '刻度标签文字的颜色，默认取 <a target="__blank" href="https://echarts.apache.org/zh/option.html#xAxis.axisLine.lineStyle.color">axisLine.lineStyle.color</a>。支持回调函数，格式如下',
      eType: "color",
    },
    fontStyle: {
      name: "fontStyle",
      nickname: "字体样式",
      desc: "文字字体的风格",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontWeight: {
      name: "fontWeight",
      nickname: "字体粗细",
      desc: "文字字体的粗细",
      value: "normal",
      defaultValue: "normal",
      type: "pureValue",
    },
    fontFamily: {
      name: "fontFamily",
      nickname: "字体",
      desc: "文字的字体系列",
      value: "sans-serif",
      defaultValue: "sans-serif",
      type: "pureValue",
    },
    fontSize: {
      name: "fontSize",
      nickname: "字体大小",
      desc: "文字的字体大小",
      value: 12,
      defaultValue: 12,
      type: "pureValue",
    },
    align: {
      name: "align",
      nickname: "对齐",
      desc: "文字水平对齐方式，默认自动。",
    },
    verticalAlign: {
      name: "verticalAlign",
      nickname: "垂直对齐",
      desc: "文字垂直对齐方式，默认自动。",
    },
    lineHeight: {
      name: "lineHeight",
      nickname: "行高",
      desc: "行高。",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "文字块背景色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "文字块边框颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "文字块边框宽度。",
      value: 0,
      defaultValue: 0,
    },
    borderRadius: {
      name: "borderRadius",
      nickname: "边框圆角",
      desc: "文字块的圆角。",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc: "文字块的内边距。例如：",
      value: 0,
      defaultValue: 0,
    },
    shadowColor: {
      name: "shadowColor",
      nickname: "阴影颜色",
      desc: "文字块的背景阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    shadowBlur: {
      name: "shadowBlur",
      nickname: "阴影长度",
      desc: "文字块的背景阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetX: {
      name: "shadowOffsetX",
      nickname: "阴影 X",
      desc: "文字块的背景阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    shadowOffsetY: {
      name: "shadowOffsetY",
      nickname: "阴影 Y",
      desc: "文字块的背景阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    width: {
      name: "width",
      nickname: "宽度",
      desc:
        '文字块的宽度。一般不用指定，不指定则自动是文字的宽度。在想做表格项或者使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    height: {
      name: "height",
      nickname: "高度",
      desc:
        '文字块的高度。一般不用指定，不指定则自动是文字的高度。在使用图片（参见 <code class="codespan">backgroundColor</code>）时，可能会使用它。',
    },
    textBorderColor: {
      name: "textBorderColor",
      nickname: "文本边框颜色",
      desc: "文字本身的描边颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textBorderWidth: {
      name: "textBorderWidth",
      nickname: "文本边框宽度",
      desc: "文字本身的描边宽度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowColor: {
      name: "textShadowColor",
      nickname: "文本阴影宽度",
      desc: "文字本身的阴影颜色。",
      value: "transparent",
      defaultValue: "transparent",
      type: "pureValue",
    },
    textShadowBlur: {
      name: "textShadowBlur",
      nickname: "文本阴影长度",
      desc: "文字本身的阴影长度。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetX: {
      name: "textShadowOffsetX",
      nickname: "文本阴影X偏移",
      desc: "文字本身的阴影 X 偏移。",
      value: 0,
      defaultValue: 0,
    },
    textShadowOffsetY: {
      name: "textShadowOffsetY",
      nickname: "文本阴影Y偏移",
      desc: "文字本身的阴影 Y 偏移。",
      value: 0,
      defaultValue: 0,
    },
    rich,
  },
}
